import { getters } from './getters';
import { mutations } from './mutations';
import { actions } from './actions';
var state = {
    userBetas: [],
    loading: false,
};
export var beta = {
    namespaced: true,
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions,
};
